import { useQuery } from "@tanstack/react-query"

import { prepareSurveyQuestions } from "./utils/prepareDataApi"

import { SurveyResult, SurveyList, SurveyQuestions, FetchQuestionnaireProfilesResponse } from "./"

import { httpClient } from "@utils/infrastructure/httpClient"

const SURVEY_LIST = "SURVEY_LIST"
const SURVEY_BY_SLUG = "SURVEY_BY_SLUG"

export function getSurveyList() {
    return httpClient.get<SurveyList[]>("survey/list")
}

export function getSurveyBySlug(slug: string) {
    return httpClient.get<SurveyQuestions>(`survey/${slug}`)
}

export function saveSurveyV2(data: SurveyResult, variant: boolean | null) {
    if (variant === null) {
        return httpClient.post<FetchQuestionnaireProfilesResponse>("survey/v2/result/add", data)
    }
    return httpClient.post<FetchQuestionnaireProfilesResponse>(
        `survey/v2/result/${variant ? 1 : 0}/add`,
        data
    )
}

export function useGetSurveyList() {
    return useQuery<SurveyList[]>({
        queryKey: [SURVEY_LIST],
        queryFn: getSurveyList,
        refetchOnWindowFocus: false,
    })
}

export function useGetSurveyBySlug(slug: string) {
    return useQuery({
        queryKey: [SURVEY_BY_SLUG, slug],
        queryFn: () => getSurveyBySlug(slug),
        enabled: !!slug,
        refetchOnWindowFocus: false,
        select: prepareSurveyQuestions,
    })
}
